import React from 'react'
import './Church.css'
import gallery_1 from '../../assets/edusity/gallery-1.png'
import gallery_2 from '../../assets/edusity/gallery-2.png'
import gallery_3 from '../../assets/edusity/gallery-3.png'
import gallery_4 from '../../assets/edusity/gallery-4.png'
import white_arrow from '../../assets/edusity/white-arrow.png'

const Church = () => {
  return (
    <div className='church'>
        <div className='gallery'>
            <img src={gallery_1} alt=''/>
            <img src={gallery_2} alt=''/>
            <img src={gallery_3} alt=''/>
            <img src={gallery_4} alt=''/>

        </div>
        <button className='btn dark-btn'> See more here <img src={white_arrow} alt='' /></button>
    </div>
  )
}

export default Church